import React from 'react';
import PropTypes from 'prop-types';

import LloydMatChooserItems from './LloydMatChooserItems';
import ProductUniquesSection from '../ProductUniques/ProductUniquesSection';
import LloydCatalogue, {getLloydItemList} from "../models/LloydCatalogue";
import {pluralize} from "../../../lib/TextHelpers";
import clsx from "clsx";
import {camelizeKeysDeep} from "../../../ReduxStore/Helpers/transformObject";

// LloydMatChooser - the section.
//      LloydMatChooserItems - container
//          LloydMatChooserItem (repeated)
//      ProductUniquesSection
//          ProductUniquePicker (repeated, only if needed for each item)
export default function LloydMatChooser({lloydCart, callbacks, lloyd}) {
  let itemList = getLloydItemList({lloyd});

  return <section id="lloyd-mat-chooser">

    <ChooserHeadline lloydCart={lloydCart} />

    <LloydMatChooserItems
      itemList={itemList}
      lloyd={lloyd}
      callbacks={callbacks}
      lloydCart={lloydCart}/>

    <ProductUniquesSection lloydCart={lloydCart} callbacks={callbacks}/>
  </section>
}

LloydMatChooser.propTypes = {
  lloyd: PropTypes.instanceOf(LloydCatalogue).isRequired,
  lloydCart: PropTypes.object.isRequired,
  callbacks: PropTypes.object,
}

function ChooserHeadline({lloydCart}) {
  let cartCount = lloydCart ? lloydCart.items.count() : 0;

  return <h2>Step 1: Begin By Selecting Mat Locations
    {cartCount > 0 ? <span> ({pluralize(cartCount, "item")} selected)</span> : null}
  </h2>
}


